export const SET_USER = 'SET_USER';
export const SET_PROFILE = 'SET_PROFILE';
export const SET_BALANCE = 'SET_BALANCE';
export const SET_USER_INFO = 'SET_USER_INFO';